
// import { useState, useEffect } from "react"
// import { Link, useParams } from "react-router-dom"
// import axios from "axios"
// import { baseUrl } from "../config/baseUrl"
// import empty from "../assets/images/empty-box.png"
// import Swal from "sweetalert2"
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
// import {
//     faQuestionCircle,
//     faPlus,
//     faEye,
//     faEdit,
//     faTrash,
//     faCheck,
//     faTimes,
//     faSearch,
// } from "@fortawesome/free-solid-svg-icons"

// export default function TestQuestions() {
//     const [questions, setQuestions] = useState([])
//     const [loading, setLoading] = useState(false)
//     const [searchTerm, setSearchTerm] = useState("")
//     const [statusFilter, setStatusFilter] = useState("")
//     const [language, setLanguage] = useState("english")

//     useEffect(() => {
//         fetchQuestions()
//     }, [])

//     const fetchQuestions = async () => {
//         try {
//             setLoading(true)
//             const response = await axios.get(`${baseUrl}/question`, {
//                 headers: {
//                     Authorization: localStorage.getItem("token"),
//                 },
//             })
//             setQuestions(response.data.data)
//         } catch (error) {
//             console.log("error", error)
//         } finally {
//             setLoading(false)
//         }
//     }

//     const handleStatus = async (id) => {
//         try {
//             await axios(`${baseUrl}/api/v1/admin/questions/${id}/status`, {
//                 method: "PATCH",
//                 headers: {
//                     Authorization: localStorage.getItem("token"),
//                 },
//             })
//             fetchQuestions()
//             Swal.fire({
//                 title: "Status Changed!",
//                 text: "Question status updated successfully",
//                 icon: "success",
//                 draggable: true,
//             })
//         } catch (error) {
//             Swal.fire({
//                 title: "Error!",
//                 text: "Failed to update status",
//                 icon: "error",
//             })
//         }
//     }

//     const handleDelete = async (id) => {
//         const result = await Swal.fire({
//             title: "Are you sure?",
//             text: "You won't be able to revert this!",
//             icon: "warning",
//             showCancelButton: true,
//             confirmButtonColor: "#d33",
//             cancelButtonColor: "#3085d6",
//             confirmButtonText: "Yes, delete it!",
//         })

//         if (result.isConfirmed) {
//             try {
//                 await axios.delete(`${baseUrl}/api/v1/admin/questions/${id}`, {
//                     headers: {
//                         Authorization: localStorage.getItem("token"),
//                     },
//                 })
//                 fetchQuestions()
//                 Swal.fire("Deleted!", "Question has been deleted.", "success")
//             } catch (error) {
//                 Swal.fire("Error!", "Failed to delete question.", "error")
//             }
//         }
//     }

//     // Move the getQuestionText function above the filteredQuestions filter

//     // Helper function to get question text based on language
//     const getQuestionText = (question, lang) => {
//         if (lang === "english") {
//             return question?.question_english || question?.questions || ""
//         } else if (lang === "hindi") {
//             return question?.question_hindi || question?.questions || ""
//         } else if (lang === "bengali") {
//             return question?.question_bengali || question?.questions || ""
//         }
//         return question?.question_english || question?.questions || ""
//     }

//     // Helper function to get option text based on language and option letter
//     const getOptionText = (question, lang, option) => {
//         if (lang === "english") {
//             return question?.[`option_${option.toLowerCase()}_english`] || question?.[`option_${option.toLowerCase()}`] || ""
//         } else if (lang === "hindi") {
//             return question?.[`option_${option.toUpperCase()}_hindi`] || question?.[`option_${option.toLowerCase()}`] || ""
//         } else if (lang === "bengali") {
//             // Bengali options use numbers instead of letters
//             const optionMap = { a: "1", b: "2", c: "3", d: "4", e: "5" }
//             return (
//                 question?.[`option_${optionMap[option.toLowerCase()]}_bengali`] ||
//                 question?.[`option_${option.toLowerCase()}`] ||
//                 ""
//             )
//         }
//         return question?.[`option_${option.toLowerCase()}_english`] || question?.[`option_${option.toLowerCase()}`] || ""
//     }

//     // Helper function to get correct answer
//     const getCorrectAnswer = (question) => {
//         return question?.correct_answer || question?.correctAnswer || ""
//     }

//     // Filter questions based on search term, status, and handle multilingual search
//     const filteredQuestions = questions.filter((question) => {
//         // Get the appropriate question text based on selected language
//         const questionText = getQuestionText(question, language)

//         const matchesSearch = questionText?.toLowerCase().includes(searchTerm.toLowerCase())
//         const matchesStatus = statusFilter === "" || question.status === statusFilter
//         return matchesSearch && matchesStatus
//     })

//     const truncateText = (text, maxLength = 50) => {
//         return text.length > maxLength ? text.substring(0, maxLength) + "..." : text
//     }


//     const { id } = useParams();
//     return (
//         <>
//             <section className="main-sec">
//                 <div className="container">
//                     <div className="row">
//                         <div className="col-lg-6">
//                             <div className="dashboard-title">
//                                 <h4 className="dash-head">
//                                     <FontAwesomeIcon icon={faQuestionCircle} className="me-2" />
//                                     Questions
//                                 </h4>
//                             </div>
//                             <div className="custom-bredcump">
//                                 <nav aria-label="breadcrumb">
//                                     <ol className="breadcrumb">
//                                         <li className="breadcrumb-item">
//                                             <Link to="/">Dashboard</Link>
//                                         </li>
//                                         <li className="breadcrumb-item active" aria-current="page">
//                                             Questions List
//                                         </li>
//                                     </ol>
//                                 </nav>
//                             </div>
//                         </div>
//                         <div className="col-lg-6 d-flex justify-content-end align-items-start">
//                             <Link to={`/test-series/questions/assign/${id}`} className="btn-add-question">
//                                 <FontAwesomeIcon icon={faPlus} className="me-2" />
//                                 Assign Question
//                             </Link>
//                         </div>
//                     </div>

//                     <div className="row">
//                         <div className="col-lg-12">
//                             <div className="cards bus-list">
//                                 <div className="bus-filter">
//                                     <div className="row align-items-center">
//                                         <div className="col-lg-6">
//                                             <h5 className="card-title">Questions List ({filteredQuestions.length})</h5>
//                                         </div>
//                                     </div>
//                                 </div>

//                                 <div className="search-filter-container">
//                                     <div className="search-container">
//                                         <FontAwesomeIcon icon={faSearch} className="search-icon" />
//                                         <input
//                                             type="text"
//                                             className="search-input"
//                                             placeholder="Search questions..."
//                                             value={searchTerm}
//                                             onChange={(e) => setSearchTerm(e.target.value)}
//                                         />
//                                     </div>
//                                     <select
//                                         className="status-filter"
//                                         value={statusFilter}
//                                         onChange={(e) => setStatusFilter(e.target.value)}
//                                     >
//                                         <option value="">All Status</option>
//                                         <option value="active">Active</option>
//                                         <option value="inactive">Inactive</option>
//                                     </select>
//                                     <select className="status-filter" value={language} onChange={(e) => setLanguage(e.target.value)}>
//                                         <option value="english">English</option>
//                                         <option value="hindi">Hindi</option>
//                                         <option value="bengali">Bengali</option>
//                                     </select>
//                                 </div>

//                                 <div className="table-responsive custom-table">
//                                     <table className="table table-borderless">
//                                         <thead>
//                                             <tr>
//                                                 <th>SN</th>
//                                                 <th>Question</th>
//                                                 {/* <th>Options</th> */}
//                                                 <th>Subject</th>
//                                                 <th>Topic</th>
//                                                 <th>Status</th>
//                                                 <th>Actions</th>
//                                             </tr>
//                                         </thead>
//                                         <tbody>
//                                             {loading ? (
//                                                 <tr>
//                                                     <td colSpan="6" className="loading-spinner">
//                                                         <div className="spinner"></div>
//                                                     </td>
//                                                 </tr>
//                                             ) : filteredQuestions.length === 0 ? (
//                                                 <tr>
//                                                     <td colSpan="6" className="empty-state">
//                                                         <img src={empty || "/placeholder.svg"} alt="No questions" width="200px" />
//                                                         <h4>No Questions found!</h4>
//                                                         <p className="text-muted">
//                                                             {searchTerm || statusFilter
//                                                                 ? "Try adjusting your search or filter criteria"
//                                                                 : "Start by adding your first question"}
//                                                         </p>
//                                                     </td>
//                                                 </tr>
//                                             ) : (
//                                                 filteredQuestions.map((question, i) => (
//                                                     <tr key={question?._id}>
//                                                         <td>{i + 1}</td>
//                                                         <td>
//                                                             <div className="question-text">
//                                                                 {truncateText(getQuestionText(question, language), 60)}
//                                                             </div>
//                                                         </td>
//                                                         <td>
//                                                             {question?.subject}
//                                                         </td>
//                                                         <td>
//                                                             {question?.topic}
//                                                         </td>
//                                                         <td>
//                                                             <button
//                                                                 onClick={() => handleStatus(question?._id)}
//                                                                 className={`status-badge ${question.status === "active" ? "status-active" : "status-inactive"
//                                                                     }`}
//                                                             >
//                                                                 {question?.status === "active" ? (
//                                                                     <>
//                                                                         <FontAwesomeIcon icon={faCheck} className="me-1" />
//                                                                         Active
//                                                                     </>
//                                                                 ) : (
//                                                                     <>
//                                                                         <FontAwesomeIcon icon={faTimes} className="me-1" />
//                                                                         Inactive
//                                                                     </>
//                                                                 )}
//                                                             </button>
//                                                         </td>
//                                                         <td>
//                                                             <div className="action-buttons">
//                                                                 <Link to={`/questions/edit/${question?._id}`} className="action-btn edit-btn">
//                                                                     <FontAwesomeIcon icon={faEdit} />
//                                                                     <span className="tooltip-text">Edit</span>
//                                                                 </Link>
//                                                                 <button className="action-btn delete-btn" onClick={() => handleDelete(question?._id)}>
//                                                                     <FontAwesomeIcon icon={faTrash} />
//                                                                     <span className="tooltip-text">Delete</span>
//                                                                 </button>
//                                                             </div>
//                                                         </td>
//                                                     </tr>
//                                                 ))
//                                             )}
//                                         </tbody>
//                                     </table>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </section>
//         </>
//     )
// }


// "use client"

// import { useState, useEffect } from "react"
// import { Link, useParams, useNavigate } from "react-router-dom"
// import axios from "axios"
// import { baseUrl } from "../config/baseUrl"
// import empty from "../assets/images/empty-box.png"
// import Swal from "sweetalert2"
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
// import {
//     faQuestionCircle,
//     faPlus,
//     faEye,
//     faEdit,
//     faTrash,
//     faCheck,
//     faTimes,
//     faSearch,
//     faArrowLeft,
// } from "@fortawesome/free-solid-svg-icons"

// export default function TestQuestions() {
//     const { id } = useParams()
//     const navigate = useNavigate()

//     const [questions, setQuestions] = useState([])
//     const [testQuestions, setTestQuestions] = useState([])
//     const [loading, setLoading] = useState(false)
//     const [loadingTest, setLoadingTest] = useState(true)
//     const [searchTerm, setSearchTerm] = useState("")
//     const [statusFilter, setStatusFilter] = useState("")
//     const [language, setLanguage] = useState("english")
//     const [testDetails, setTestDetails] = useState(null)
//     const [subjectFilter, setSubjectFilter] = useState("")
//     const [subjects, setSubjects] = useState([])
//     useEffect(() => {
//         fetchTestDetails()
//     }, [id])

//     useEffect(() => {
//         // Extract unique subjects from questions
//         if (testQuestions.length > 0) {
//             const uniqueSubjects = [...new Set(testQuestions.map((q) => q.subject).filter(Boolean))]
//             setSubjects(uniqueSubjects)
//         }
//     }, [testQuestions])

//     const fetchTestDetails = async () => {
//         try {
//             setLoadingTest(true)
//             const response = await axios.get(`${baseUrl}/test`, {
//                 headers: {
//                     Authorization: localStorage.getItem("token"),
//                 },
//             })

//             if (response.data.status) {
//                 const testList = response.data.data || []
//                 const test = testList.find((t) => t._id === id)

//                 if (test) {
//                     setTestDetails(test)
//                     // If test has questions, fetch them
//                     if (test.questions && Array.isArray(test.questions) && test.questions.length > 0) {
//                         fetchTestQuestions(test.questions)
//                     } else {
//                         setTestQuestions([])
//                         setLoadingTest(false)
//                     }
//                 } else {
//                     Swal.fire({
//                         title: "Error!",
//                         text: "Test not found",
//                         icon: "error",
//                     })
//                     navigate("/test-series")
//                 }
//             }
//         } catch (error) {
//             console.error("Error fetching test details:", error)
//             Swal.fire({
//                 title: "Error!",
//                 text: "Failed to fetch test details",
//                 icon: "error",
//             })
//             setLoadingTest(false)
//         }
//     }

//     const fetchTestQuestions = async (questionIds) => {
//         try {
//             setLoading(true)
//             const response = await axios.post(`${baseUrl}/question_selected/test-questions`, {
//                 headers: {
//                     Authorization: localStorage.getItem("token"),
//                 },
//                 data: { testId: id }
//             })

//             if (response.data.status) {
//                 const allQuestions = response.data.data || []
//                 // Filter questions that belong to this test
//                 const testQuestionsData = allQuestions.filter((q) => questionIds.includes(q._id))
//                 setTestQuestions(testQuestionsData)
//                 setQuestions(allQuestions) // Keep all questions for reference
//             }
//         } catch (error) {
//             console.error("Error fetching questions:", error)
//             Swal.fire({
//                 title: "Error!",
//                 text: "Failed to fetch questions",
//                 icon: "error",
//             })
//         } finally {
//             setLoading(false)
//             setLoadingTest(false)
//         }
//     }

//     const handleStatus = async (id) => {
//         try {
//             await axios(`${baseUrl}/api/v1/admin/questions/${id}/status`, {
//                 method: "PATCH",
//                 headers: {
//                     Authorization: localStorage.getItem("token"),
//                 },
//             })

//             // Update the status in our local state
//             setTestQuestions((prevQuestions) =>
//                 prevQuestions.map((q) => (q._id === id ? { ...q, status: q.status === "active" ? "inactive" : "active" } : q)),
//             )

//             Swal.fire({
//                 title: "Status Changed!",
//                 text: "Question status updated successfully",
//                 icon: "success",
//                 timer: 1500,
//                 showConfirmButton: false,
//             })
//         } catch (error) {
//             Swal.fire({
//                 title: "Error!",
//                 text: "Failed to update status",
//                 icon: "error",
//             })
//         }
//     }

//     const handleRemoveQuestion = async (questionId) => {
//         const result = await Swal.fire({
//             title: "Remove Question?",
//             text: "Are you sure you want to remove this question from the test?",
//             icon: "warning",
//             showCancelButton: true,
//             confirmButtonColor: "#d33",
//             cancelButtonColor: "#3085d6",
//             confirmButtonText: "Yes, remove it!",
//         })

//         if (result.isConfirmed) {
//             try {
//                 // Get current questions assigned to the test
//                 const updatedQuestions = testDetails.questions.filter((qId) => qId !== questionId)

//                 // Call API to update the test with the removed question
//                 const response = await axios.put(
//                     `${baseUrl}/test/${id}`,
//                     {
//                         questions: updatedQuestions,
//                     },
//                     {
//                         headers: {
//                             Authorization: localStorage.getItem("token"),
//                             "Content-Type": "application/json",
//                         },
//                     },
//                 )

//                 if (response.data.status) {
//                     // Update local state
//                     setTestDetails({
//                         ...testDetails,
//                         questions: updatedQuestions,
//                     })

//                     // Remove from displayed questions
//                     setTestQuestions((prevQuestions) => prevQuestions.filter((q) => q._id !== questionId))

//                     Swal.fire({
//                         title: "Removed!",
//                         text: "Question has been removed from the test.",
//                         icon: "success",
//                         timer: 1500,
//                         showConfirmButton: false,
//                     })
//                 } else {
//                     Swal.fire({
//                         title: "Error!",
//                         text: response.data.message || "Failed to remove question",
//                         icon: "error",
//                     })
//                 }
//             } catch (error) {
//                 console.error("Error removing question:", error)
//                 Swal.fire({
//                     title: "Error!",
//                     text: "Failed to remove question from test",
//                     icon: "error",
//                 })
//             }
//         }
//     }

//     // Helper function to get question text based on language
//     const getQuestionText = (question, lang) => {
//         if (lang === "english") {
//             return question?.question_english || question?.questions || ""
//         } else if (lang === "hindi") {
//             return question?.question_hindi || question?.questions || ""
//         } else if (lang === "bengali") {
//             return question?.question_bengali || question?.questions || ""
//         }
//         return question?.question_english || question?.questions || ""
//     }

//     // Helper function to get option text based on language and option letter
//     const getOptionText = (question, lang, option) => {
//         if (lang === "english") {
//             return question?.[`option_${option.toLowerCase()}_english`] || question?.[`option_${option.toLowerCase()}`] || ""
//         } else if (lang === "hindi") {
//             return question?.[`option_${option.toUpperCase()}_hindi`] || question?.[`option_${option.toLowerCase()}`] || ""
//         } else if (lang === "bengali") {
//             // Bengali options use numbers instead of letters
//             const optionMap = { a: "1", b: "2", c: "3", d: "4", e: "5" }
//             return (
//                 question?.[`option_${optionMap[option.toLowerCase()]}_bengali`] ||
//                 question?.[`option_${option.toLowerCase()}`] ||
//                 ""
//             )
//         }
//         return question?.[`option_${option.toLowerCase()}_english`] || question?.[`option_${option.toLowerCase()}`] || ""
//     }

//     // Helper function to get correct answer
//     const getCorrectAnswer = (question) => {
//         return question?.correct_answer || question?.correctAnswer || ""
//     }

//     // Filter questions based on search term, status, subject, and handle multilingual search
//     const filteredQuestions = testQuestions.filter((question) => {
//         // Get the appropriate question text based on selected language
//         const questionText = getQuestionText(question, language)
//         const subject = question?.subject || ""
//         const topic = question?.topic || ""

//         const matchesSearch =
//             questionText?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//             subject?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//             topic?.toLowerCase().includes(searchTerm.toLowerCase())

//         const matchesStatus = statusFilter === "" || question.status === statusFilter
//         const matchesSubject = subjectFilter === "" || question.subject === subjectFilter

//         return matchesSearch && matchesStatus && matchesSubject
//     })

//     const truncateText = (text, maxLength = 50) => {
//         if (!text) return ""
//         return text.length > maxLength ? text.substring(0, maxLength) + "..." : text
//     }

//     if (loadingTest) {
//         return (
//             <section className="main-sec">
//                 <div className="container">
//                     <div className="row">
//                         <div className="col-lg-12 text-center py-5">
//                             <div className="spinner-border text-primary" role="status">
//                                 <span className="visually-hidden">Loading...</span>
//                             </div>
//                             <p className="mt-3">Loading test details...</p>
//                         </div>
//                     </div>
//                 </div>
//             </section>
//         )
//     }

//     return (
//         <>
//             <style jsx>{`
//         .main-sec {
//           background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
//           min-height: 100vh;
//           padding: 2rem 0;
//         }

//         .dashboard-title {
//           margin-bottom: 1.5rem;
//         }

//         .dash-head {
//           color: #333;
//           font-size: 1.8rem;
//           font-weight: 700;
//           margin: 0;
//         }

//         .cards {
//           background: white;
//           border-radius: 15px;
//           padding: 2rem;
//           box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
//           margin-bottom: 2rem;
//         }

//         .bus-filter {
//           margin-bottom: 2rem;
//           padding-bottom: 1.5rem;
//           border-bottom: 1px solid #eee;
//         }

//         .card-title {
//           color: #333;
//           font-weight: 700;
//           margin: 0;
//         }

//         .btn-add-question {
//           background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
//           border: none;
//           border-radius: 8px;
//           padding: 0.75rem 1.5rem;
//           color: white;
//           font-weight: 600;
//           text-decoration: none;
//           transition: all 0.3s ease;
//         }

//         .btn-add-question:hover {
//           transform: translateY(-2px);
//           box-shadow: 0 10px 20px rgba(102, 126, 234, 0.3);
//           color: white;
//         }

//         .search-filter-container {
//           display: flex;
//           gap: 1rem;
//           margin-bottom: 1.5rem;
//           flex-wrap: wrap;
//         }

//         .search-input {
//           flex: 1;
//           min-width: 250px;
//           border-radius: 8px;
//           border: 1px solid #ddd;
//           padding: 0.75rem 1rem;
//           padding-left: 2.5rem;
//           position: relative;
//         }

//         .search-container {
//           position: relative;
//           flex: 1;
//           min-width: 250px;
//         }

//         .search-icon {
//           position: absolute;
//           left: 0.75rem;
//           top: 50%;
//           transform: translateY(-50%);
//           color: #999;
//         }

//         .status-filter, .subject-filter {
//           border-radius: 8px;
//           border: 1px solid #ddd;
//           padding: 0.75rem 1rem;
//           min-width: 150px;
//         }

//         .custom-table {
//           border-radius: 10px;
//           overflow: hidden;
//         }

//         .table {
//           margin: 0;
//         }

//         .table thead th {
//           background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
//           color: white;
//           font-weight: 600;
//           border: none;
//           padding: 1rem;
//         }

//         .table tbody td {
//           padding: 1rem;
//           vertical-align: middle;
//           border-bottom: 1px solid #f0f0f0;
//         }

//         .table tbody tr:hover {
//           background-color: #f8f9ff;
//         }

//         .question-text {
//           max-width: 300px;
//           font-weight: 500;
//         }

//         .status-badge {
//           padding: 0.5rem 1rem;
//           border-radius: 20px;
//           font-size: 0.85rem;
//           font-weight: 600;
//           border: none;
//           cursor: pointer;
//           transition: all 0.3s ease;
//         }

//         .status-active {
//           background: #d4edda;
//           color: #155724;
//         }

//         .status-inactive {
//           background: #f8d7da;
//           color: #721c24;
//         }

//         .status-badge:hover {
//           transform: scale(1.05);
//         }

//         .action-buttons {
//           display: flex;
//           gap: 0.5rem;
//         }

//         .action-btn {
//           width: 35px;
//           height: 35px;
//           border-radius: 8px;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           border: none;
//           cursor: pointer;
//           transition: all 0.3s ease;
//           position: relative;
//         }

//         .action-btn:hover {
//           transform: translateY(-2px);
//         }

//         .action-btn:hover .tooltip-text {
//           visibility: visible;
//           opacity: 1;
//         }

//         .edit-btn {
//           background: #4facfe;
//           color: white;
//         }

//         .delete-btn {
//           background: #ef5350;
//           color: white;
//         }

//         .view-btn {
//           background: #26c6da;
//           color: white;
//         }

//         .tooltip-text {
//           visibility: hidden;
//           width: 80px;
//           background-color: #333;
//           color: #fff;
//           text-align: center;
//           border-radius: 6px;
//           padding: 5px;
//           position: absolute;
//           z-index: 1;
//           bottom: 125%;
//           left: 50%;
//           margin-left: -40px;
//           opacity: 0;
//           transition: opacity 0.3s;
//           font-size: 0.75rem;
//         }

//         .tooltip-text::after {
//           content: "";
//           position: absolute;
//           top: 100%;
//           left: 50%;
//           margin-left: -5px;
//           border-width: 5px;
//           border-style: solid;
//           border-color: #333 transparent transparent transparent;
//         }

//         .empty-state {
//           text-align: center;
//           padding: 3rem;
//         }

//         .empty-state img {
//           opacity: 0.7;
//           margin-bottom: 1rem;
//         }

//         .empty-state h4 {
//           color: #666;
//           margin-bottom: 1rem;
//         }

//         .loading-spinner {
//           display: flex;
//           justify-content: center;
//           align-items: center;
//           padding: 3rem;
//         }

//         .spinner {
//           width: 40px;
//           height: 40px;
//           border: 4px solid #f3f3f3;
//           border-top: 4px solid #667eea;
//           border-radius: 50%;
//           animation: spin 1s linear infinite;
//         }

//         .test-info {
//           background: #f8f9ff;
//           border-left: 4px solid #667eea;
//           padding: 1rem;
//           border-radius: 8px;
//           margin-bottom: 1.5rem;
//         }

//         .test-info h5 {
//           color: #333;
//           font-weight: 700;
//           margin-bottom: 0.5rem;
//         }

//         .test-info p {
//           margin-bottom: 0.25rem;
//           color: #666;
//         }

//         .test-info .badge {
//           font-size: 0.85rem;
//           padding: 0.35em 0.65em;
//           margin-left: 0.5rem;
//         }

//         @keyframes spin {
//           0% { transform: rotate(0deg); }
//           100% { transform: rotate(360deg); }
//         }

//         @media (max-width: 768px) {
//           .search-filter-container {
//             flex-direction: column;
//           }

//           .search-container,
//           .status-filter,
//           .subject-filter {
//             min-width: 100%;
//           }

//           .table-responsive {
//             font-size: 0.85rem;
//           }

//           .question-text {
//             max-width: 200px;
//           }
//         }
//       `}</style>

//             <section className="main-sec">
//                 <div className="container">
//                     <div className="row">
//                         <div className="col-lg-6">
//                             <div className="dashboard-title">
//                                 <h4 className="dash-head">
//                                     <FontAwesomeIcon icon={faQuestionCircle} className="me-2" />
//                                     Test Questions
//                                 </h4>
//                             </div>
//                             <div className="custom-bredcump">
//                                 <nav aria-label="breadcrumb">
//                                     <ol className="breadcrumb">
//                                         <li className="breadcrumb-item">
//                                             <Link to="/">Dashboard</Link>
//                                         </li>
//                                         <li className="breadcrumb-item">
//                                             <Link to="/test-series">Tests</Link>
//                                         </li>
//                                         <li className="breadcrumb-item active" aria-current="page">
//                                             Test Questions
//                                         </li>
//                                     </ol>
//                                 </nav>
//                             </div>
//                         </div>
//                         <div className="col-lg-6 d-flex justify-content-end align-items-start">
//                             <Link to={`/test-series/questions/assign/${id}`} className="btn-add-question me-2">
//                                 <FontAwesomeIcon icon={faPlus} className="me-2" />
//                                 Assign Questions
//                             </Link>
//                             <Link to="/test-series" className="btn-add-question" style={{ background: "#4facfe" }}>
//                                 <FontAwesomeIcon icon={faArrowLeft} className="me-2" />
//                                 Back to Tests
//                             </Link>
//                         </div>
//                     </div>

//                     {/* {testDetails && (
//                         <div className="row mb-4">
//                             <div className="col-lg-12">
//                                 <div className="test-info">
//                                     <h5>
//                                         {testDetails.title}
//                                         <span className={`badge ${testDetails.status === "active" ? "bg-success" : "bg-danger"}`}>
//                                             {testDetails.status}
//                                         </span>
//                                     </h5>
//                                     <p>
//                                         <strong>Language:</strong> {testDetails.language}
//                                     </p>
//                                     <p>
//                                         <strong>Duration:</strong> {testDetails.duration} minutes
//                                     </p>
//                                     <p>
//                                         <strong>Total Marks:</strong> {testDetails.marks}
//                                     </p>
//                                     <p>
//                                         <strong>Questions:</strong> {testQuestions.length}
//                                     </p>
//                                 </div>
//                             </div>
//                         </div>
//                     )} */}

//                     <div className="row">
//                         <div className="col-lg-12">
//                             <div className="cards bus-list">
//                                 <div className="bus-filter">
//                                     <div className="row align-items-center">
//                                         <div className="col-lg-6">
//                                             <h5 className="card-title">Questions List ({filteredQuestions.length})</h5>
//                                         </div>
//                                     </div>
//                                 </div>

//                                 <div className="search-filter-container">
//                                     <div className="search-container">
//                                         <FontAwesomeIcon icon={faSearch} className="search-icon" />
//                                         <input
//                                             type="text"
//                                             className="search-input"
//                                             placeholder="Search questions..."
//                                             value={searchTerm}
//                                             onChange={(e) => setSearchTerm(e.target.value)}
//                                         />
//                                     </div>
//                                     <select
//                                         className="status-filter"
//                                         value={statusFilter}
//                                         onChange={(e) => setStatusFilter(e.target.value)}
//                                     >
//                                         <option value="">All Status</option>
//                                         <option value="active">Active</option>
//                                         <option value="inactive">Inactive</option>
//                                     </select>
//                                     {subjects.length > 0 && (
//                                         <select
//                                             className="subject-filter"
//                                             value={subjectFilter}
//                                             onChange={(e) => setSubjectFilter(e.target.value)}
//                                         >
//                                             <option value="">All Subjects</option>
//                                             {subjects.map((subject) => (
//                                                 <option key={subject} value={subject}>
//                                                     {subject}
//                                                 </option>
//                                             ))}
//                                         </select>
//                                     )}
//                                     <select className="status-filter" value={language} onChange={(e) => setLanguage(e.target.value)}>
//                                         <option value="english">English</option>
//                                         <option value="hindi">Hindi</option>
//                                         <option value="bengali">Bengali</option>
//                                     </select>
//                                 </div>

//                                 <div className="table-responsive custom-table">
//                                     <table className="table table-borderless">
//                                         <thead>
//                                             <tr>
//                                                 <th>SN</th>
//                                                 <th>Question</th>
//                                                 <th>Subject</th>
//                                                 <th>Topic</th>
//                                                 <th>Status</th>
//                                                 <th>Actions</th>
//                                             </tr>
//                                         </thead>
//                                         <tbody>
//                                             {loading ? (
//                                                 <tr>
//                                                     <td colSpan="6" className="loading-spinner">
//                                                         <div className="spinner"></div>
//                                                     </td>
//                                                 </tr>
//                                             ) : filteredQuestions.length === 0 ? (
//                                                 <tr>
//                                                     <td colSpan="6" className="empty-state">
//                                                         <img src={empty || "/placeholder.svg"} alt="No questions" width="200px" />
//                                                         <h4>No Questions found!</h4>
//                                                         <p className="text-muted">
//                                                             {searchTerm || statusFilter || subjectFilter
//                                                                 ? "Try adjusting your search or filter criteria"
//                                                                 : "This test has no questions assigned yet"}
//                                                         </p>
//                                                         <Link to={`/test-series/questions/assign/${id}`} className="btn-add-question mt-3">
//                                                             <FontAwesomeIcon icon={faPlus} className="me-2" />
//                                                             Assign Questions
//                                                         </Link>
//                                                     </td>
//                                                 </tr>
//                                             ) : (
//                                                 filteredQuestions.map((question, i) => (
//                                                     <tr key={question?._id}>
//                                                         <td>{i + 1}</td>
//                                                         <td>
//                                                             <div className="question-text">
//                                                                 {truncateText(getQuestionText(question, language), 60)}
//                                                             </div>
//                                                         </td>
//                                                         <td>{question?.subject || "N/A"}</td>
//                                                         <td>{question?.topic || "N/A"}</td>
//                                                         <td>
//                                                             <span
//                                                                 className={`status-badge ${question.status === "active" ? "status-active" : "status-inactive"
//                                                                     }`}
//                                                             >
//                                                                 {question?.status === "active" ? (
//                                                                     <>
//                                                                         <FontAwesomeIcon icon={faCheck} className="me-1" />
//                                                                         Active
//                                                                     </>
//                                                                 ) : (
//                                                                     <>
//                                                                         <FontAwesomeIcon icon={faTimes} className="me-1" />
//                                                                         Inactive
//                                                                     </>
//                                                                 )}
//                                                             </span>
//                                                         </td>
//                                                         <td>
//                                                             <div className="action-buttons">
//                                                                 <Link to={`/questions/view/${question?._id}`} className="action-btn view-btn">
//                                                                     <FontAwesomeIcon icon={faEye} />
//                                                                     <span className="tooltip-text">View</span>
//                                                                 </Link>
//                                                                 <Link to={`/questions/edit/${question?._id}`} className="action-btn edit-btn">
//                                                                     <FontAwesomeIcon icon={faEdit} />
//                                                                     <span className="tooltip-text">Edit</span>
//                                                                 </Link>
//                                                                 <button
//                                                                     className="action-btn delete-btn"
//                                                                     onClick={() => handleRemoveQuestion(question?._id)}
//                                                                 >
//                                                                     <FontAwesomeIcon icon={faTrash} />
//                                                                     <span className="tooltip-text">Remove</span>
//                                                                 </button>
//                                                             </div>
//                                                         </td>
//                                                     </tr>
//                                                 ))
//                                             )}
//                                         </tbody>
//                                     </table>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </section>
//         </>
//     )
// }


























// "use client"

// import { useState, useEffect } from "react"
// import { Link, useParams, useNavigate } from "react-router-dom"
// import axios from "axios"
// import { baseUrl } from "../config/baseUrl"
// import empty from "../assets/images/empty-box.png"
// import Swal from "sweetalert2"
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
// import {
//     faEye,
//     faEdit,
//     faTrash,
//     faCheck,
//     faTimes,
//     faSearch,
//     faArrowLeft,
//     faUser,
// } from "@fortawesome/free-solid-svg-icons"

// export default function TestQuestions() {
//     const { id } = useParams()
//     const navigate = useNavigate()

//     const [testQuestions, setTestQuestions] = useState([])
//     const [loading, setLoading] = useState(false)
//     const [loadingTest, setLoadingTest] = useState(true)
//     const [searchTerm, setSearchTerm] = useState("")
//     const [statusFilter, setStatusFilter] = useState("")
//     const [examFilter, setExamFilter] = useState("")
//     const [testDetails, setTestDetails] = useState(null)
//     const [exams, setExams] = useState([])

//     useEffect(() => {
//         fetchTestQuestions()
//     }, [id])

//     useEffect(() => {
//         // Extract unique exams from questions
//         if (testQuestions.length > 0) {
//             const uniqueExams = [...new Set(testQuestions.map((q) => q.exam).filter(Boolean))]
//             setExams(uniqueExams)
//         }
//     }, [testQuestions])

//     const fetchTestQuestions = async () => {
//         try {
//             setLoading(true)
//             setLoadingTest(true)

//             const response = await axios.post(
//                 `${baseUrl}/question_selected/test-questions`,
//                 { testId: id },
//                 {
//                     headers: {
//                         Authorization: localStorage.getItem("token"),
//                         "Content-Type": "application/json",
//                     },
//                 },
//             )

//             if (response.data.status) {
//                 const questionsData = response.data.data || []
//                 setTestQuestions(questionsData)
//             } else {
//                 Swal.fire({
//                     title: "Error!",
//                     text: response.data.message || "Failed to fetch test questions",
//                     icon: "error",
//                 })
//             }
//         } catch (error) {
//             console.error("Error fetching test questions:", error)
//             Swal.fire({
//                 title: "Error!",
//                 text: "Failed to fetch test questions",
//                 icon: "error",
//             })
//         } finally {
//             setLoading(false)
//             setLoadingTest(false)
//         }
//     }

//     const handleStatus = async (questionId) => {
//         try {
//             // Update the status in our local state
//             setTestQuestions((prevQuestions) =>
//                 prevQuestions.map((q) =>
//                     q._id === questionId ? { ...q, status: q.status === "active" ? "inactive" : "active" } : q,
//                 ),
//             )

//             Swal.fire({
//                 title: "Status Changed!",
//                 text: "Question status updated successfully",
//                 icon: "success",
//                 timer: 1500,
//                 showConfirmButton: false,
//             })
//         } catch (error) {
//             Swal.fire({
//                 title: "Error!",
//                 text: "Failed to update status",
//                 icon: "error",
//             })
//         }
//     }

//     const handleRemoveQuestion = async (questionId) => {
//         const result = await Swal.fire({
//             title: "Remove Question?",
//             text: "Are you sure you want to remove this question from the test?",
//             icon: "warning",
//             showCancelButton: true,
//             confirmButtonColor: "#d33",
//             cancelButtonColor: "#3085d6",
//             confirmButtonText: "Yes, remove it!",
//         })

//         if (result.isConfirmed) {
//             try {
//                 // Remove from displayed questions
//                 setTestQuestions((prevQuestions) => prevQuestions.filter((q) => q._id !== questionId))

//                 Swal.fire({
//                     title: "Removed!",
//                     text: "Question has been removed from the test.",
//                     icon: "success",
//                     timer: 1500,
//                     showConfirmButton: false,
//                 })
//             } catch (error) {
//                 console.error("Error removing question:", error)
//                 Swal.fire({
//                     title: "Error!",
//                     text: "Failed to remove question from test",
//                     icon: "error",
//                 })
//             }
//         }
//     }

//     // Filter questions based on search term, status, and exam
//     const filteredQuestions = testQuestions.filter((question) => {
//         const name = question?.name || ""
//         const rollNumber = question?.roll_number || ""
//         const city = question?.city || ""
//         const state = question?.state || ""
//         const exam = question?.exam || ""

//         const matchesSearch =
//             name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//             rollNumber?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//             city?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//             state?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//             exam?.toLowerCase().includes(searchTerm.toLowerCase())

//         const matchesStatus = statusFilter === "" || question.status === statusFilter
//         const matchesExam = examFilter === "" || question.exam === examFilter

//         return matchesSearch && matchesStatus && matchesExam
//     })

//     const formatDate = (dateString) => {
//         const date = new Date(dateString)
//         return date.toLocaleDateString("en-US", {
//             year: "numeric",
//             month: "short",
//             day: "numeric",
//         })
//     }

//     if (loadingTest) {
//         return (
//             <section className="main-sec">
//                 <div className="container">
//                     <div className="row">
//                         <div className="col-lg-12 text-center py-5">
//                             <div className="spinner-border text-primary" role="status">
//                                 <span className="visually-hidden">Loading...</span>
//                             </div>
//                             <p className="mt-3">Loading test questions...</p>
//                         </div>
//                     </div>
//                 </div>
//             </section>
//         )
//     }

//     return (
//         <>
//             <style jsx>{`
//         .main-sec {
//           background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
//           min-height: 100vh;
//           padding: 2rem 0;
//         }

//         .dashboard-title {
//           margin-bottom: 1.5rem;
//         }

//         .dash-head {
//           color: #333;
//           font-size: 1.8rem;
//           font-weight: 700;
//           margin: 0;
//         }

//         .cards {
//           background: white;
//           border-radius: 15px;
//           padding: 2rem;
//           box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
//           margin-bottom: 2rem;
//         }

//         .bus-filter {
//           margin-bottom: 2rem;
//           padding-bottom: 1.5rem;
//           border-bottom: 1px solid #eee;
//         }

//         .card-title {
//           color: #333;
//           font-weight: 700;
//           margin: 0;
//         }

//         .btn-add-question {
//           background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
//           border: none;
//           border-radius: 8px;
//           padding: 0.75rem 1.5rem;
//           color: white;
//           font-weight: 600;
//           text-decoration: none;
//           transition: all 0.3s ease;
//         }

//         .btn-add-question:hover {
//           transform: translateY(-2px);
//           box-shadow: 0 10px 20px rgba(102, 126, 234, 0.3);
//           color: white;
//         }

//         .search-filter-container {
//           display: flex;
//           gap: 1rem;
//           margin-bottom: 1.5rem;
//           flex-wrap: wrap;
//         }

//         .search-input {
//           flex: 1;
//           min-width: 250px;
//           border-radius: 8px;
//           border: 1px solid #ddd;
//           padding: 0.75rem 1rem;
//           padding-left: 2.5rem;
//           position: relative;
//         }

//         .search-container {
//           position: relative;
//           flex: 1;
//           min-width: 250px;
//         }

//         .search-icon {
//           position: absolute;
//           left: 0.75rem;
//           top: 50%;
//           transform: translateY(-50%);
//           color: #999;
//         }

//         .status-filter, .exam-filter {
//           border-radius: 8px;
//           border: 1px solid #ddd;
//           padding: 0.75rem 1rem;
//           min-width: 150px;
//         }

//         .custom-table {
//           border-radius: 10px;
//           overflow: hidden;
//         }

//         .table {
//           margin: 0;
//         }

//         .table thead th {
//           background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
//           color: white;
//           font-weight: 600;
//           border: none;
//           padding: 1rem;
//         }

//         .table tbody td {
//           padding: 1rem;
//           vertical-align: middle;
//           border-bottom: 1px solid #f0f0f0;
//         }

//         .table tbody tr:hover {
//           background-color: #f8f9ff;
//         }

//         .candidate-info {
//           display: flex;
//           align-items: center;
//           gap: 0.75rem;
//         }

//         .candidate-photo {
//           width: 40px;
//           height: 40px;
//           border-radius: 50%;
//           object-fit: cover;
//           border: 2px solid #ddd;
//         }

//         .candidate-details h6 {
//           margin: 0;
//           font-weight: 600;
//           color: #333;
//         }

//         .candidate-details small {
//           color: #666;
//         }

//         .status-badge {
//           padding: 0.5rem 1rem;
//           border-radius: 20px;
//           font-size: 0.85rem;
//           font-weight: 600;
//           border: none;
//           cursor: pointer;
//           transition: all 0.3s ease;
//         }

//         .status-active {
//           background: #d4edda;
//           color: #155724;
//         }

//         .status-inactive {
//           background: #f8d7da;
//           color: #721c24;
//         }

//         .status-badge:hover {
//           transform: scale(1.05);
//         }

//         .action-buttons {
//           display: flex;
//           gap: 0.5rem;
//         }

//         .action-btn {
//           width: 35px;
//           height: 35px;
//           border-radius: 8px;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           border: none;
//           cursor: pointer;
//           transition: all 0.3s ease;
//           position: relative;
//         }

//         .action-btn:hover {
//           transform: translateY(-2px);
//         }

//         .action-btn:hover .tooltip-text {
//           visibility: visible;
//           opacity: 1;
//         }

//         .edit-btn {
//           background: #4facfe;
//           color: white;
//         }

//         .delete-btn {
//           background: #ef5350;
//           color: white;
//         }

//         .view-btn {
//           background: #26c6da;
//           color: white;
//         }

//         .tooltip-text {
//           visibility: hidden;
//           width: 80px;
//           background-color: #333;
//           color: #fff;
//           text-align: center;
//           border-radius: 6px;
//           padding: 5px;
//           position: absolute;
//           z-index: 1;
//           bottom: 125%;
//           left: 50%;
//           margin-left: -40px;
//           opacity: 0;
//           transition: opacity 0.3s;
//           font-size: 0.75rem;
//         }

//         .tooltip-text::after {
//           content: "";
//           position: absolute;
//           top: 100%;
//           left: 50%;
//           margin-left: -5px;
//           border-width: 5px;
//           border-style: solid;
//           border-color: #333 transparent transparent transparent;
//         }

//         .empty-state {
//           text-align: center;
//           padding: 3rem;
//         }

//         .empty-state img {
//           opacity: 0.7;
//           margin-bottom: 1rem;
//         }

//         .empty-state h4 {
//           color: #666;
//           margin-bottom: 1rem;
//         }

//         .loading-spinner {
//           display: flex;
//           justify-content: center;
//           align-items: center;
//           padding: 3rem;
//         }

//         .spinner {
//           width: 40px;
//           height: 40px;
//           border: 4px solid #f3f3f3;
//           border-top: 4px solid #667eea;
//           border-radius: 50%;
//           animation: spin 1s linear infinite;
//         }

//         .exam-badge {
//           background: #e3f2fd;
//           color: #1976d2;
//           padding: 0.25rem 0.5rem;
//           border-radius: 4px;
//           font-size: 0.8rem;
//           font-weight: 600;
//         }

//         @keyframes spin {
//           0% { transform: rotate(0deg); }
//           100% { transform: rotate(360deg); }
//         }

//         @media (max-width: 768px) {
//           .search-filter-container {
//             flex-direction: column;
//           }

//           .search-container,
//           .status-filter,
//           .exam-filter {
//             min-width: 100%;
//           }

//           .table-responsive {
//             font-size: 0.85rem;
//           }

//           .candidate-info {
//             flex-direction: column;
//             text-align: center;
//           }
//         }
//       `}</style>

//             <section className="main-sec">
//                 <div className="container">
//                     <div className="row">
//                         <div className="col-lg-6">
//                             <div className="dashboard-title">
//                                 <h4 className="dash-head">
//                                     <FontAwesomeIcon icon={faUser} className="me-2" />
//                                     Test Candidates
//                                 </h4>
//                             </div>
//                             <div className="custom-bredcump">
//                                 <nav aria-label="breadcrumb">
//                                     <ol className="breadcrumb">
//                                         <li className="breadcrumb-item">
//                                             <Link to="/">Dashboard</Link>
//                                         </li>
//                                         <li className="breadcrumb-item">
//                                             <Link to="/test-series">Tests</Link>
//                                         </li>
//                                         <li className="breadcrumb-item active" aria-current="page">
//                                             Test Candidates
//                                         </li>
//                                     </ol>
//                                 </nav>
//                             </div>
//                         </div>
//                         <div className="col-lg-6 d-flex justify-content-end align-items-start">
//                             <Link to="/test-series" className="btn-add-question" style={{ background: "#4facfe" }}>
//                                 <FontAwesomeIcon icon={faArrowLeft} className="me-2" />
//                                 Back to Tests
//                             </Link>
//                         </div>
//                     </div>

//                     <div className="row">
//                         <div className="col-lg-12">
//                             <div className="cards bus-list">
//                                 <div className="bus-filter">
//                                     <div className="row align-items-center">
//                                         <div className="col-lg-6">
//                                             <h5 className="card-title">Candidates List ({filteredQuestions.length})</h5>
//                                         </div>
//                                     </div>
//                                 </div>

//                                 <div className="search-filter-container">
//                                     <div className="search-container">
//                                         <FontAwesomeIcon icon={faSearch} className="search-icon" />
//                                         <input
//                                             type="text"
//                                             className="search-input"
//                                             placeholder="Search by name, roll number, city, state, or exam..."
//                                             value={searchTerm}
//                                             onChange={(e) => setSearchTerm(e.target.value)}
//                                         />
//                                     </div>
//                                     <select
//                                         className="status-filter"
//                                         value={statusFilter}
//                                         onChange={(e) => setStatusFilter(e.target.value)}
//                                     >
//                                         <option value="">All Status</option>
//                                         <option value="active">Active</option>
//                                         <option value="inactive">Inactive</option>
//                                     </select>
//                                     {exams.length > 0 && (
//                                         <select className="exam-filter" value={examFilter} onChange={(e) => setExamFilter(e.target.value)}>
//                                             <option value="">All Exams</option>
//                                             {exams.map((exam) => (
//                                                 <option key={exam} value={exam}>
//                                                     {exam}
//                                                 </option>
//                                             ))}
//                                         </select>
//                                     )}
//                                 </div>

//                                 <div className="table-responsive custom-table">
//                                     <table className="table table-borderless">
//                                         <thead>
//                                             <tr>
//                                                 <th>SN</th>
//                                                 <th>Candidate</th>
//                                                 <th>Roll Number</th>
//                                                 <th>Exam</th>
//                                                 <th>Year</th>
//                                                 <th>Location</th>
//                                                 <th>Selected Date</th>
//                                                 <th>Status</th>
//                                                 <th>Actions</th>
//                                             </tr>
//                                         </thead>
//                                         <tbody>
//                                             {loading ? (
//                                                 <tr>
//                                                     <td colSpan="9" className="loading-spinner">
//                                                         <div className="spinner"></div>
//                                                     </td>
//                                                 </tr>
//                                             ) : filteredQuestions.length === 0 ? (
//                                                 <tr>
//                                                     <td colSpan="9" className="empty-state">
//                                                         <img src={empty || "/placeholder.svg"} alt="No candidates" width="200px" />
//                                                         <h4>No Candidates found!</h4>
//                                                         <p className="text-muted">
//                                                             {searchTerm || statusFilter || examFilter
//                                                                 ? "Try adjusting your search or filter criteria"
//                                                                 : "No candidates have been selected for this test yet"}
//                                                         </p>
//                                                     </td>
//                                                 </tr>
//                                             ) : (
//                                                 filteredQuestions.map((candidate, i) => (
//                                                     <tr key={candidate?._id}>
//                                                         <td>{i + 1}</td>
//                                                         <td>
//                                                             <div className="candidate-info">
//                                                                 <img
//                                                                     src={candidate?.photo || "/placeholder.svg?height=40&width=40"}
//                                                                     alt={candidate?.name}
//                                                                     className="candidate-photo"
//                                                                     onError={(e) => {
//                                                                         e.target.src = "/placeholder.svg?height=40&width=40"
//                                                                     }}
//                                                                 />
//                                                                 <div className="candidate-details">
//                                                                     <h6>{candidate?.name}</h6>
//                                                                 </div>
//                                                             </div>
//                                                         </td>
//                                                         <td>
//                                                             <strong>{candidate?.roll_number}</strong>
//                                                         </td>
//                                                         <td>
//                                                             <span className="exam-badge">{candidate?.exam}</span>
//                                                         </td>
//                                                         <td>{candidate?.exam_year}</td>
//                                                         <td>
//                                                             <div>
//                                                                 <div>{candidate?.city}</div>
//                                                                 <small className="text-muted">{candidate?.state}</small>
//                                                             </div>
//                                                         </td>
//                                                         <td>{formatDate(candidate?.selectedAt)}</td>
//                                                         <td>
//                                                             <button
//                                                                 className={`status-badge ${candidate.status === "active" ? "status-active" : "status-inactive"
//                                                                     }`}
//                                                                 onClick={() => handleStatus(candidate._id)}
//                                                             >
//                                                                 {candidate?.status === "active" ? (
//                                                                     <>
//                                                                         <FontAwesomeIcon icon={faCheck} className="me-1" />
//                                                                         Active
//                                                                     </>
//                                                                 ) : (
//                                                                     <>
//                                                                         <FontAwesomeIcon icon={faTimes} className="me-1" />
//                                                                         Inactive
//                                                                     </>
//                                                                 )}
//                                                             </button>
//                                                         </td>
//                                                         <td>
//                                                             <div className="action-buttons">
//                                                                 <button className="action-btn view-btn">
//                                                                     <FontAwesomeIcon icon={faEye} />
//                                                                     <span className="tooltip-text">View</span>
//                                                                 </button>
//                                                                 <button className="action-btn edit-btn">
//                                                                     <FontAwesomeIcon icon={faEdit} />
//                                                                     <span className="tooltip-text">Edit</span>
//                                                                 </button>
//                                                                 <button
//                                                                     className="action-btn delete-btn"
//                                                                     onClick={() => handleRemoveQuestion(candidate?._id)}
//                                                                 >
//                                                                     <FontAwesomeIcon icon={faTrash} />
//                                                                     <span className="tooltip-text">Remove</span>
//                                                                 </button>
//                                                             </div>
//                                                         </td>
//                                                     </tr>
//                                                 ))
//                                             )}
//                                         </tbody>
//                                     </table>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </section>
//         </>
//     )
// }



















"use client"

import { useState, useEffect } from "react"
import { Link, useParams, useNavigate } from "react-router-dom"
import axios from "axios"
import { baseUrl } from "../config/baseUrl"
import empty from "../assets/images/empty-box.png"
import Swal from "sweetalert2"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
    faQuestionCircle,
    faPlus,
    faEye,
    faEdit,
    faTrash,
    faCheck,
    faTimes,
    faSearch,
    faArrowLeft,
    faLanguage,
} from "@fortawesome/free-solid-svg-icons"

export default function TestQuestions() {
    const { id } = useParams()
    const navigate = useNavigate()

    const [testQuestions, setTestQuestions] = useState([])
    const [loading, setLoading] = useState(false)
    const [loadingTest, setLoadingTest] = useState(true)
    const [searchTerm, setSearchTerm] = useState("")
    const [statusFilter, setStatusFilter] = useState("")
    const [language, setLanguage] = useState("english")
    const [testDetails, setTestDetails] = useState(null)
    const [subjectFilter, setSubjectFilter] = useState("")
    const [subjects, setSubjects] = useState([])

    useEffect(() => {
        fetchTestQuestions()
    }, [id])

    useEffect(() => {
        // Extract unique subjects from questions
        if (testQuestions.length > 0) {
            const uniqueSubjects = [...new Set(testQuestions.map((q) => q.subject).filter(Boolean))]
            setSubjects(uniqueSubjects)
        }
    }, [testQuestions])

    const fetchTestQuestions = async () => {
        try {
            setLoading(true)
            setLoadingTest(true)

            const response = await axios.post(
                `${baseUrl}/question_selected/test-questions`,
                { testId: id },
                {
                    headers: {
                        Authorization: localStorage.getItem("token"),
                        "Content-Type": "application/json",
                    },
                },
            )

            if (response.data.status) {
                const questionsData = response.data.data || []
                setTestQuestions(questionsData)
            } else {
                Swal.fire({
                    title: "Error!",
                    text: response.data.message || "Failed to fetch test questions",
                    icon: "error",
                })
            }
        } catch (error) {
            console.error("Error fetching test questions:", error)
        } finally {
            setLoading(false)
            setLoadingTest(false)
        }
    }

    const handleStatus = async (questionId) => {
        try {
            // Update the status in our local state
            setTestQuestions((prevQuestions) =>
                prevQuestions.map((q) =>
                    q._id === questionId ? { ...q, status: q.status === "active" ? "inactive" : "active" } : q,
                ),
            )

            Swal.fire({
                title: "Status Changed!",
                text: "Question status updated successfully",
                icon: "success",
                timer: 1500,
                showConfirmButton: false,
            })
        } catch (error) {
            Swal.fire({
                title: "Error!",
                text: "Failed to update status",
                icon: "error",
            })
        }
    }



    // Inside your component
    const { id: testId } = useParams();

    const handleRemoveQuestion = async (questionId) => {
        const result = await Swal.fire({
            title: "Remove Question?",
            text: "Are you sure you want to remove this question from the test?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, remove it!",
        });

        if (result.isConfirmed) {
            try {
                const response = await fetch(`${baseUrl}/question_selected/selected-question-delete`, {
                    method: "DELETE",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: localStorage.getItem("token"),
                    },
                    body: JSON.stringify({
                        questionId,
                        testId,
                    }),
                });

                if (!response.ok) {
                    throw new Error("Failed to remove question from test");
                }

                await response.json();

                // Remove question from local state
                setTestQuestions((prevQuestions) =>
                    prevQuestions.filter((q) => q._id !== questionId)
                );

                Swal.fire({
                    title: "Removed!",
                    text: "Question has been removed from the test.",
                    icon: "success",
                    timer: 1500,
                    showConfirmButton: false,
                });
            } catch (error) {
                console.error("Error removing question:", error);
                Swal.fire({
                    title: "Error!",
                    text: "Failed to remove question from test",
                    icon: "error",
                });
            }
        }
    };


    // Helper function to get question text based on language
    const getQuestionText = (question, lang) => {
        switch (lang.toLowerCase()) {
            case "english":
                return question?.question_english || ""
            case "hindi":
                return question?.question_hindi || ""
            case "bengali":
                return question?.question_bengali || ""
            default:
                return question?.question_english || ""
        }
    }

    // Helper function to get option text based on language
    const getOptionText = (question, lang, optionKey) => {
        switch (lang.toLowerCase()) {
            case "english":
                return question?.[`option_${optionKey.toLowerCase()}_english`] || ""
            case "hindi":
                return question?.[`option_${optionKey.toUpperCase()}_hindi`] || ""
            case "bengali":
                // Bengali uses numbers (1,2,3,4) instead of letters
                const optionMap = { a: "1", b: "2", c: "3", d: "4", e: "5" }
                return question?.[`option_${optionMap[optionKey.toLowerCase()]}_bengali`] || ""
            default:
                return question?.[`option_${optionKey.toLowerCase()}_english`] || ""
        }
    }

    // Helper function to get explanation
    const getExplanation = (question, lang) => {
        switch (lang.toLowerCase()) {
            case "english":
                return question?.explanation_english || ""
            case "hindi":
                return question?.explanation_hindi || ""
            case "bengali":
                return question?.explanation_bengali || ""
            default:
                return question?.explanation_english || ""
        }
    }

    // Filter questions based on search term, status, subject, and handle multilingual search
    const filteredQuestions = testQuestions.filter((question) => {
        const questionText = getQuestionText(question, language)
        const subject = question?.subject || ""
        const topic = question?.topic || ""

        const matchesSearch =
            questionText?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            subject?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            topic?.toLowerCase().includes(searchTerm.toLowerCase())

        const matchesStatus = statusFilter === "" || question.status === statusFilter
        const matchesSubject = subjectFilter === "" || question.subject === subjectFilter

        return matchesSearch && matchesStatus && matchesSubject
    })

    const truncateText = (text, maxLength = 80) => {
        if (!text) return ""
        return text.length > maxLength ? text.substring(0, maxLength) + "..." : text
    }

    const formatDate = (dateString) => {
        const date = new Date(dateString)
        return date.toLocaleDateString("en-US", {
            year: "numeric",
            month: "short",
            day: "numeric",
        })
    }

    if (loadingTest) {
        return (
            <section className="main-sec">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 text-center py-5">
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                            <p className="mt-3">Loading test questions...</p>
                        </div>
                    </div>
                </div>
            </section>
        )
    }

    return (
        <>
            <style jsx>{`
        .main-sec {
          background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
          min-height: 100vh;
          padding: 2rem 0;
        }

        .dashboard-title {
          margin-bottom: 1.5rem;
        }

        .dash-head {
          color: #333;
          font-size: 1.8rem;
          font-weight: 700;
          margin: 0;
        }

        .cards {
          background: white;
          border-radius: 15px;
          padding: 2rem;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
          margin-bottom: 2rem;
        }

        .bus-filter {
          margin-bottom: 2rem;
          padding-bottom: 1.5rem;
          border-bottom: 1px solid #eee;
        }

        .card-title {
          color: #333;
          font-weight: 700;
          margin: 0;
        }

        .btn-add-question {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          border: none;
          border-radius: 8px;
          padding: 0.75rem 1.5rem;
          color: white;
          font-weight: 600;
          text-decoration: none;
          transition: all 0.3s ease;
        }

        .btn-add-question:hover {
          transform: translateY(-2px);
          box-shadow: 0 10px 20px rgba(102, 126, 234, 0.3);
          color: white;
        }

        .search-filter-container {
          display: flex;
          gap: 1rem;
          margin-bottom: 1.5rem;
          flex-wrap: wrap;
        }

        .search-input {
          flex: 1;
          min-width: 250px;
          border-radius: 8px;
          border: 1px solid #ddd;
          padding: 0.75rem 1rem;
          padding-left: 2.5rem;
          position: relative;
        }

        .search-container {
          position: relative;
          flex: 1;
          min-width: 250px;
        }

        .search-icon {
          position: absolute;
          left: 0.75rem;
          top: 50%;
          transform: translateY(-50%);
          color: #999;
        }

        .status-filter, .subject-filter, .language-filter {
          border-radius: 8px;
          border: 1px solid #ddd;
          padding: 0.75rem 1rem;
          min-width: 150px;
        }

        .custom-table {
          border-radius: 10px;
          overflow: hidden;
        }

        .table {
          margin: 0;
        }

        .table thead th {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          color: white;
          font-weight: 600;
          border: none;
          padding: 1rem;
        }

        .table tbody td {
          padding: 1rem;
          vertical-align: middle;
          border-bottom: 1px solid #f0f0f0;
        }

        .table tbody tr:hover {
          background-color: #f8f9ff;
        }

        .question-text {
          max-width: 400px;
          font-weight: 500;
          line-height: 1.4;
        }

        .options-preview {
          font-size: 0.85rem;
          color: #666;
          margin-top: 0.5rem;
        }

        .correct-answer {
          background: #d4edda;
          color: #155724;
          padding: 0.25rem 0.5rem;
          border-radius: 4px;
          font-weight: 600;
          font-size: 0.85rem;
        }

        .status-badge {
          padding: 0.5rem 1rem;
          border-radius: 20px;
          font-size: 0.85rem;
          font-weight: 600;
          border: none;
          cursor: pointer;
          transition: all 0.3s ease;
        }

        .status-active {
          background: #d4edda;
          color: #155724;
        }

        .status-inactive {
          background: #f8d7da;
          color: #721c24;
        }

        .status-badge:hover {
          transform: scale(1.05);
        }

        .action-buttons {
          display: flex;
          gap: 0.5rem;
        }

        .action-btn {
          width: 35px;
          height: 35px;
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          border: none;
          cursor: pointer;
          transition: all 0.3s ease;
          position: relative;
        }

        .action-btn:hover {
          transform: translateY(-2px);
        }

        .action-btn:hover .tooltip-text {
          visibility: visible;
          opacity: 1;
        }

        .edit-btn {
          background: #4facfe;
          color: white;
        }

        .delete-btn {
          background: #ef5350;
          color: white;
        }

        .view-btn {
          background: #26c6da;
          color: white;
        }

        .tooltip-text {
          visibility: hidden;
          width: 80px;
          background-color: #333;
          color: #fff;
          text-align: center;
          border-radius: 6px;
          padding: 5px;
          position: absolute;
          z-index: 1;
          bottom: 125%;
          left: 50%;
          margin-left: -40px;
          opacity: 0;
          transition: opacity 0.3s;
          font-size: 0.75rem;
        }

        .tooltip-text::after {
          content: "";
          position: absolute;
          top: 100%;
          left: 50%;
          margin-left: -5px;
          border-width: 5px;
          border-style: solid;
          border-color: #333 transparent transparent transparent;
        }

        .empty-state {
          text-align: center;
          padding: 3rem;
        }

        .empty-state img {
          opacity: 0.7;
          margin-bottom: 1rem;
        }

        .empty-state h4 {
          color: #666;
          margin-bottom: 1rem;
        }

        .loading-spinner {
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 3rem;
        }

        .spinner {
          width: 40px;
          height: 40px;
          border: 4px solid #f3f3f3;
          border-top: 4px solid #667eea;
          border-radius: 50%;
          animation: spin 1s linear infinite;
        }

        .subject-badge {
          background: #e3f2fd;
          color: #1976d2;
          padding: 0.25rem 0.5rem;
          border-radius: 4px;
          font-size: 0.8rem;
          font-weight: 600;
        }

        .topic-badge {
          background: #f3e5f5;
          color: #7b1fa2;
          padding: 0.25rem 0.5rem;
          border-radius: 4px;
          font-size: 0.8rem;
          font-weight: 600;
          margin-top: 0.25rem;
          display: inline-block;
        }

        .language-indicator {
          background: #fff3cd;
          color: #856404;
          padding: 0.25rem 0.5rem;
          border-radius: 4px;
          font-size: 0.75rem;
          font-weight: 600;
          margin-left: 0.5rem;
        }

        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }

        @media (max-width: 768px) {
          .search-filter-container {
            flex-direction: column;
          }
          
          .search-container,
          .status-filter,
          .subject-filter,
          .language-filter {
            min-width: 100%;
          }
          
          .table-responsive {
            font-size: 0.85rem;
          }
          
          .question-text {
            max-width: 250px;
          }
        }
      `}</style>

            <section className="main-sec">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="dashboard-title">
                                <h4 className="dash-head">
                                    <FontAwesomeIcon icon={faQuestionCircle} className="me-2" />
                                    Test Questions
                                    <span className="language-indicator">
                                        <FontAwesomeIcon icon={faLanguage} className="me-1" />
                                        {language.charAt(0).toUpperCase() + language.slice(1)}
                                    </span>
                                </h4>
                            </div>
                            <div className="custom-bredcump">
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item">
                                            <Link to="/">Dashboard</Link>
                                        </li>
                                        <li className="breadcrumb-item">
                                            <Link to="/test-series">Tests</Link>
                                        </li>
                                        <li className="breadcrumb-item active" aria-current="page">
                                            Test Questions
                                        </li>
                                    </ol>
                                </nav>
                            </div>
                        </div>
                        <div className="col-lg-6 d-flex justify-content-end align-items-start">
                            <Link to={`/test-series/questions/assign/${id}`} className="btn-add-question me-2">
                                <FontAwesomeIcon icon={faPlus} className="me-2" />
                                Assign Questions
                            </Link>
                            <Link to="/test-series" className="btn-add-question" style={{ background: "#4facfe" }}>
                                <FontAwesomeIcon icon={faArrowLeft} className="me-2" />
                                Back to Tests
                            </Link>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-lg-12">
                            <div className="cards bus-list">
                                <div className="bus-filter">
                                    <div className="row align-items-center">
                                        <div className="col-lg-6">
                                            <h5 className="card-title">Questions List ({filteredQuestions.length})</h5>
                                        </div>
                                    </div>
                                </div>

                                <div className="search-filter-container">
                                    <div className="search-container">
                                        <FontAwesomeIcon icon={faSearch} className="search-icon" />
                                        <input
                                            type="text"
                                            className="search-input"
                                            placeholder="Search questions, subjects, or topics..."
                                            value={searchTerm}
                                            onChange={(e) => setSearchTerm(e.target.value)}
                                        />
                                    </div>
                                    <select
                                        className="status-filter"
                                        value={statusFilter}
                                        onChange={(e) => setStatusFilter(e.target.value)}
                                    >
                                        <option value="">All Status</option>
                                        <option value="active">Active</option>
                                        <option value="inactive">Inactive</option>
                                    </select>
                                    {subjects.length > 0 && (
                                        <select
                                            className="subject-filter"
                                            value={subjectFilter}
                                            onChange={(e) => setSubjectFilter(e.target.value)}
                                        >
                                            <option value="">All Subjects</option>
                                            {subjects.map((subject) => (
                                                <option key={subject} value={subject}>
                                                    {subject}
                                                </option>
                                            ))}
                                        </select>
                                    )}
                                    <select className="language-filter" value={language} onChange={(e) => setLanguage(e.target.value)}>
                                        <option value="english">English</option>
                                        <option value="hindi">Hindi</option>
                                        <option value="bengali">Bengali</option>
                                    </select>
                                </div>

                                <div className="table-responsive custom-table">
                                    <table className="table table-borderless">
                                        <thead>
                                            <tr>
                                                <th>SN</th>
                                                <th>Question</th>
                                                <th>Subject & Topic</th>
                                                <th>Correct Answer</th>
                                                <th>Created</th>
                                                <th>Status</th>
                                                <th>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {loading ? (
                                                <tr>
                                                    <td colSpan="7" className="loading-spinner">
                                                        <div className="spinner"></div>
                                                    </td>
                                                </tr>
                                            ) : filteredQuestions.length === 0 ? (
                                                <tr>
                                                    <td colSpan="7" className="empty-state">
                                                        <img src={empty || "/placeholder.svg"} alt="No questions" width="200px" />
                                                        <h4>No Questions found!</h4>
                                                        <p className="text-muted">
                                                            {searchTerm || statusFilter || subjectFilter
                                                                ? "Try adjusting your search or filter criteria"
                                                                : "This test has no questions assigned yet"}
                                                        </p>
                                                        <Link to={`/test-series/questions/assign/${id}`} className="btn-add-question mt-3">
                                                            <FontAwesomeIcon icon={faPlus} className="me-2" />
                                                            Assign Questions
                                                        </Link>
                                                    </td>
                                                </tr>
                                            ) : (
                                                filteredQuestions.map((question, i) => (
                                                    <tr key={question?._id}>
                                                        <td>{i + 1}</td>
                                                        <td>
                                                            <div className="question-text">
                                                                {truncateText(getQuestionText(question, language), 100)}
                                                                {/* <div className="options-preview">
                                                                    A: {truncateText(getOptionText(question, language, "a"), 30)}
                                                                    <br />
                                                                    B: {truncateText(getOptionText(question, language, "b"), 30)}
                                                                </div> */}
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div>
                                                                <span className="subject-badge">{question?.subject || "N/A"}</span>
                                                                {question?.topic && (
                                                                    <div className="topic-badge">{truncateText(question.topic, 30)}</div>
                                                                )}
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <span className="correct-answer">Option {question?.correct_answer || "N/A"}</span>
                                                        </td>
                                                        <td>{formatDate(question?.createdAt)}</td>
                                                        <td>
                                                            <button
                                                                className={`status-badge ${question.status === "active" ? "status-active" : "status-inactive"
                                                                    }`}
                                                                onClick={() => handleStatus(question._id)}
                                                            >
                                                                {question?.status === "active" ? (
                                                                    <>
                                                                        <FontAwesomeIcon icon={faCheck} className="me-1" />
                                                                        Active
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <FontAwesomeIcon icon={faTimes} className="me-1" />
                                                                        Inactive
                                                                    </>
                                                                )}
                                                            </button>
                                                        </td>
                                                        <td>
                                                            <div className="action-buttons">
                                                                {/* <Link to={`/questions/view/${question?._id}`} className="action-btn view-btn">
                                                                    <FontAwesomeIcon icon={faEye} />
                                                                    <span className="tooltip-text">View</span>
                                                                </Link>
                                                                <Link to={`/questions/edit/${question?._id}`} className="action-btn edit-btn">
                                                                    <FontAwesomeIcon icon={faEdit} />
                                                                    <span className="tooltip-text">Edit</span>
                                                                </Link> */}
                                                                <button
                                                                    className="action-btn delete-btn"
                                                                    onClick={() => handleRemoveQuestion(question?._id)}
                                                                >
                                                                    <FontAwesomeIcon icon={faTrash} />
                                                                    <span className="tooltip-text">Remove</span>
                                                                </button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
